import { styled } from '@mui/material'

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px'
}))
